// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "client-viewer/" + ({"1877":"CompactMobile","2948":"Cards","5772":"CardsMobile","5888":"Calendar","7464":"SingleEvent","8408":"EmptyState","9036":"ListLayout","9932":"SideBySide"}[chunkId] || chunkId) + ".chunk.min.js";
};